import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const Remarks = () => {
  const { id } = useParams();
  const [demand, setDemand] = useState(null);
  const [list, setList] = useState([]);
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get(`/demand-remarks/${id}`);
      setDemand(res.data.demand);
      setList(res.data.list);
    } catch (e) {
      console.error("Fetch error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const save = () => {
    if (!remark.trim()) {
      Swal.fire("Warning!", "Please write a remark first.", "warning");
      return;
    }

    Http.post(`/demand-remarks/${id}`, { remarks: remark })
      .then((res) => {
        Swal.fire("Done!", res.data.message, "success");
        setRemark("");
        fetchData();
      })
      .catch((e) => {
        Swal.fire("Failed!", e.response?.data?.message || "Something went wrong.", "error");
      });
  };

  const cols = [
    { field: "remarks", header: "Remarks" },
    { field: (item) => (item.created_by ? item.created_by.name : ""), header: "By" },
    { field: "created_at", header: "Created At" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Remarks of Demand No. - {demand ? demand.receipt_no : ""}</h5>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-10">
                <textarea
                  className="form-control"
                  placeholder="Write a remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
              <div className="col-2">
                <button className="btn btn-primary btn-block" onClick={save}>
                  <i className="fa fa-plus mg-r-6"></i> Add
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="am-pagebody" style={{ paddingTop: "0px" }}>
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable cols={cols} receiveData={list} isLoading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Remarks;
